import { configureStore } from '@reduxjs/toolkit'; 
import parameterReducer from './parameterSlice';

export default configureStore({
    reducer : {
        parameter : parameterReducer
    }
})